export function setLoader(data) {
  return {
    type: 'SETTING_LOADER_STATE',
    data,
  }
}